import { useState } from 'react';
import { postAPI } from '../../services/api.service';

export function useForgotPassword() {
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (email: string) => {
    setLoading(true);
    try {
      const response = await postAPI(`auth/forgot-password/request-otp`, { email });
      if (response.status === 200) {
        return true;
      } else {
        console.error('Failed to send OTP:', response.error);
        return false;
      }
    } catch (err) {
      console.error('Error sending OTP:', err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { handleForgotPassword, loading };
}